import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '维度实体',
    type: 'ARRD_DE',
}
